var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "toast" },
    [
      _c(
        "transition-group",
        { attrs: { name: "slide-fade-right" } },
        _vm._l(_vm.messages, function(message) {
          return _c(
            "div",
            {
              key: message.id,
              staticClass: "toast__message",
              class: { error: message.type === "error" }
            },
            [
              _c("p", {
                staticClass: "toast__message__copy",
                domProps: { innerHTML: _vm._s(message.text) }
              }),
              message.callback
                ? _c("v-button", {
                    staticClass: "toast__message__cta",
                    attrs: {
                      small: true,
                      secondary: true,
                      label: message.label
                    },
                    on: { click: message.callback }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }